// @flow
import React, { Component, lazy, Suspense } from "react";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { PersonType } from "../../types/PersonTypes";
import { LoadingProgress } from "imagus-components";

const DatabaseItem = lazy((): * => import("./DatabaseItem"));

const styles = (theme: DictionaryType): DictionaryType => ({
  divider: {
    marginTop: "10px",
    marginBottom: "10px"
  }
});

type DatabaseListClassesType = {
  divider: DictionaryType
};

type DatabaseListPropsType = {
  classes: DatabaseListClassesType,
  checkedIds: Array<string>,
  selectedId: string,
  people: Array<PersonType>,
  openSnackbar: Function,
  handleToggle: Function,
  deletePerson: Function,
  updating: { [key: string]: * },
  getEnrolments: Function
};

class DatabaseList extends Component<DatabaseListPropsType, *> {
  render(): * {
    const people = this.props.people;
    const selectPeople = people.filter(
      (x: PersonType): Function => x.uid === this.props.selectedId
    )[0];

    let checkedPeople = people.filter(
      (x: PersonType): Function => this.props.checkedIds.indexOf(x.uid) > -1
    );
    if (this.props.selectedId !== "") {
      checkedPeople = checkedPeople.filter(
        (x: PersonType): Function => x.uid !== this.props.selectedId
      );
    }

    return (
      <Grid container spacing={8}>
        {this.props.selectedId !== "" && (
          <Suspense fallback={<LoadingProgress />} key="raised">
            <DatabaseItem
              person={selectPeople}
              raised
              checked={
                this.props.checkedIds.indexOf(this.props.selectedId) > -1
              }
              openSnackbar={this.props.openSnackbar}
              handleToggle={this.props.handleToggle}
              deletePerson={this.props.deletePerson}
              updating={this.props.updating}
              getEnrolments={this.props.getEnrolments}
            />
          </Suspense>
        )}
        <Grid item xs={12}>
          <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
        </Grid>
        {checkedPeople.map((person: PersonType, i: number): * => (
          <Suspense fallback={<LoadingProgress />} key={"database" + i}>
            <DatabaseItem
              person={person}
              checked={this.props.checkedIds.indexOf(person.uid) > -1}
              openSnackbar={this.props.openSnackbar}
              handleToggle={this.props.handleToggle}
              deletePerson={this.props.deletePerson}
              updating={this.props.updating}
              getEnrolments={this.props.getEnrolments}
            />
          </Suspense>
        ))}
      </Grid>
    );
  }
}

export default withStyles(styles)(DatabaseList);
